module.exports = __webpack_public_path__ + "img/MoveIn.1712a802.svg";